import { SVGProps } from "react";

const STIGhost = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Ghost" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#e8e9eb" /><path stroke="#3d515b" strokeWidth={61} d="M101 134h187zm246 0h61zM101 257h310zm0 121h123zm187 0h123z" /></svg>;

export { STIGhost };